<template>
  <div>

    <div class="row">
      <div class="col">
        <div class="card">
          <!-- Card header -->
          <div class="card-header border-0">
            <div class="row">
              <div class="col">
                <h3>{{ configuracion.titulo.toUpperCase() }}</h3>
                <!-- <pre>{{`pagina: ${this.pagina} - limit: ${this.limit}`}}</pre> -->
              </div>

              <div class="col">
                <div class="spinner-3" v-show="spinner"></div>
              </div>
              <div class="col text-right">

                <button v-show="configuracion.btn_nuevo"
                  :class="`btn ${configuracion.clase_boton_crear ? configuracion.clase_boton_crear : 'btn-primary'}`"
                  @click="nuevo">{{ configuracion.titulo_boton }}</button>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col">
                <slot name="adicional">
                  <button v-if="configuracion.mostrar_pdf == true" class="btn btn-sm btn-danger ml-2" @click="generarPDF()">
                    <i class="fas fa-file"></i>
                    PDF
                  </button>
                </slot>
              </div>
              <div class="col text-right">
                <button class="btn btn-sm btn-primary ml-2" @click="limpiar_filtros()">
                  <i class="fas fa-recycle"></i>
                  Limpiar Filtros
                </button>
              </div>
            </div>


            <slot name="alert"></slot>
            <!-- <div class="row">
                <div class="col-md-1">
                  <select class="form-control" v-model="limit" @change="cargar">
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                        <option value="999999999">Todos</option>
                  </select>
                </div>
              </div> -->
          </div>

          <!-- Light table -->
          <div class="table-responsive" style="height:600px;">
            <table class="table align-items-center table-flush">
              <thead class="">
                <tr class="cabecera1 thead-skyblue4">
                  <th class="text-center" v-if="seleccionable" scope="col">
                    <input type="checkbox" :checked="todosSeleccionados" @change="toggleSeleccionTodos">
                  </th>
                  <!-- <th scope="col" class="sort" data-sort="name">Rut</th> -->
                  <th class="text-center" v-for="(col, index) in cols" :key="index" scope="col">{{ col.label }}</th>
                  <th class="text-center" v-for="b in botones" :key="b.key">{{ b.label }}</th>
                  <th class="text-center" v-for="b in botones_restringidos" :key="b.key">{{ b.label }}</th>
                  <th class="text-center" v-for="accion in acciones" :key="accion.key">{{ accion.label }}</th>
                </tr>
                <tr class="cabecera2 thead-skyblue3">
                  <th v-if="seleccionable"></th>
                  <!-- <th scope="col" class="sort" data-sort="name">Rut</th> -->
                  <th class="text-center" v-for="(col, index) in cols" :key="index" scope="col">

                    <input
                      v-if="(col.tipo == 'string' || col.tipo == 'string_badge' || col.tipo == 'html') && col.searchable"
                      class="form-control form-control-sm" type="text" v-model="col.busqueda"
                      @input="buscarConEspera(false)" placeholder="Buscar..." style="min-width:100px;">


                    <select v-if="col.tipo == 'html_select' && col.searchable" class="form-control"
                      v-model="col.busqueda" @change="cargar(false)">
                      <option value="">-- Sin Selección --</option>
                      <option v-for="(opc, index) in col.opciones" :key="index"
                        :value="devuelve_valor(opc, col.valor_opcion)">{{ devuelve_valor(opc, col.label_opcion) }}
                      </option>
                    </select>

                    <select v-if="col.tipo == 'select' && col.searchable" class="form-control" v-model="col.busqueda"
                      @change="cargar(false)">
                      <option value="">-- Sin Selección --</option>
                      <option v-for="(opc, index) in col.opciones" :key="index"
                        :value="devuelve_valor(opc, col.valor_opcion)">{{ devuelve_valor(opc, col.label_opcion) }}
                      </option>
                    </select>

                    <!-- <div class="form-group" v-if="col.tipo == 'multiselect'">
                            <select class="form-control js-example-basic-multiple" v-model="col.busqueda" multiple @change="cargar">
                                <option value="">-- Sin Selección --</option>
                                <option v-for="(opc,index) in col.opciones" :key="index" :value="devuelve_valor(opc,col.valor_opcion)">{{devuelve_valor(opc,col.label_opcion)}}</option>
                            </select>
                        </div> -->

                    <v-select v-if="col.tipo == 'multiselect'" style="background-color:#fff" class=""
                      @input="cargar(false)" :reduce="option => option.id" v-model="col.busqueda"
                      :options="col.opciones" :label="col.label_opcion" multiple>
                      <template v-slot:no-options="{ search, searching }">
                        <template v-if="searching">
                          No se Encontraron Resultados Para <em>{{ search }}</em>.
                        </template>
                        <em style="opacity: 0.5;" v-else>Escriba para Filtrar...</em>
                      </template>
                    </v-select>

                    <input v-if="col.tipo == 'number' && col.searchable" class="form-control form-control-sm"
                      type="number" v-model="col.busqueda" @input="cargar(false)" placeholder="Buscar...">

                    <input v-if="(col.tipo == 'datetime' || col.tipo == 'date') && col.searchable"
                      v-model="col.busqueda" @change="cargar(false)" class="form-control" type="date" value="" id="">

                    <v-select v-if="col.tipo == 'select-loadable' && col.searchable"
                      :style="`background-color:#fff;width:${col.width ? col.width : 150}px`" width="200" class=""
                      @search="filtrarOpciones($event, col, index)" @input="cargar(false)" :reduce="option => option.id"
                      v-model="col.busqueda" :options="col.opciones" :label="col.label_opcion">
                      <template v-slot:no-options="{ search, searching }">
                        <template v-if="searching">
                          No se Encontraron Resultados Para <em>{{ search }}</em>.
                        </template>
                        <em style="opacity: 0.5;" v-else>Escriba para Filtrar...</em>
                      </template>
                    </v-select>

                    <v-select v-if="col.tipo == 'select-loadable-dependiente' && col.searchable"
                      style="background-color:#fff" class="" @search="filtrarOpcionesDependiente($event, col, index)"
                      @input="cargar(false)" :reduce="option => option.id" v-model="col.busqueda"
                      :options="col.opciones" :label="col.label_opcion">
                      <template v-slot:no-options="{ search, searching }">
                        <template v-if="searching">
                          No se Encontraron Resultados Para <em>{{ search }}</em>.
                        </template>
                        <em style="opacity: 0.5;" v-else>Escriba para Filtrar...</em>
                      </template>
                    </v-select>

                  </th>
                  <th v-for="b in botones" :key="b.key"></th>
                  <th v-for="b in botones_restringidos" :key="b.key"></th>


                  <th class="text-center" v-for="accion in acciones" :key="accion.key"></th>


                </tr>
              </thead>
              <tbody class="list">

                <tr v-for="(item, index) in lista" :key="index" :class="`${item.clase ? item.clase : ''}`">
                  <td class="text-center" v-if="seleccionable">
                    <input type="checkbox" :checked="estaSeleccionado(item.id)" @change="toggleSeleccion(item.id)">
                  </td>
                  <td class="budget text-center" v-for="(col, idx) in cols" :key="idx">

                    <slot :name="col.slot || ''" v-bind:item="item">
                      <span
                        v-if="col.tipo == 'string' || col.tipo == 'multiselect' || col.tipo == 'select' || col.tipo == 'datetime' || col.tipo == 'date' || col.tipo == 'select-loadable' || col.tipo == 'select-loadable-dependiente'">{{
                          devuelve_valor(item, col.path, col.tipo) }}</span>
                      <span v-if="col.tipo == 'number'">{{ devuelve_valor(item, col.path, col.tipo) |
                        formatear_miles }}</span>

                      <span v-if="col.tipo == 'string_badge'">
                        {{ devuelve_valor(item, col.path, col.tipo) }} <span
                          v-if="devuelve_valor(item, col.mostrar_badge, col.tipo)"
                          :class="`badge badge-${devuelve_valor(item, col.color_badge, col.tipo)}`">{{
                            devuelve_valor(item,
                              col.path_badge, col.tipo) }}</span>
                      </span>


                      <p v-if="devuelve_valor(item, col.path, col.tipo) && col.tipo == 'icono'"><i :class="col.icono"
                          :style="col.style"></i> {{ devuelve_valor(item, col.path, col.tipo) }}</p>




                      <span v-if="col.tipo == 'icono_true_false'">
                        <i :class="col.icono_true" :style="col.style_true"
                          v-if="devuelve_valor(item, col.path, col.tipo)"></i><!-- true -->
                        <i :class="col.icono_false" :style="col.style_false"
                          v-if="!devuelve_valor(item, col.path, col.tipo)"></i><!-- false -->
                      </span>


                      <span v-if="col.tipo == 'select-editable'">
                        <v-select style="background-color:#fff" class="" @search="filtrarOpciones($event, col, idx)"
                          :reduce="option => option.id" v-model="item[col.key]" :options="col.opciones"
                          :label="col.label_opcion">
                          <template v-slot:no-options="{ search, searching }">
                            <template v-if="searching">
                              No se Encontraron Resultados Para <em>{{ search }}</em>.
                            </template>
                            <em style="opacity: 0.5;" v-else>Escriba para Filtrar...</em>
                          </template>
                        </v-select>
                      </span>

                      <input v-if="col.tipo == 'string-editable'" type="text" name=""
                        :placeholder="col.placeholder ? col.placeholder : ''" id="" v-model="item[col.key]">

                      <div v-if="col.tipo == 'html' || col.tipo == 'html_select'"
                        v-html="devuelve_valor(item, col.path, col.tipo)">
                      </div>
                    </slot>
                  </td>

                  <td class="text-center" v-for="b in botones" :key="b.key">
                    <button v-show="mostrar_boton(item, b)" class="btn-icon" @click="emitir(item, index, b)">
                      <i :class="b.icono" :style="{ color: obtenerColor(b.clase) }"></i>
                    </button>
                  </td>

                  <td class="text-center" v-for="b in botones_restringidos" :key="b.key">
                    <button v-if="verificar_permiso(b.permiso) && verificar_condicion(item, b.path_condicion)"
                      class="btn-icon" @click="emitir(item, index, b)">
                      <i :class="b.icono" :style="{ color: obtenerColor(b.clase) }"></i>
                    </button>
                  </td>

                  <td class="text-center" v-for="accion in acciones" :key="accion.key">

                    <select v-if="accion.tipo == 'select'" class="form-control" @change="emitir_evento">
                      <option value="">-- Sin Selección --</option>
                      <option v-for="(opc, index) in accion.opciones" :key="index"
                        :value="devuelve_valor(opc, accion.valor_opcion)">
                        {{ devuelve_valor(opc, accion.label_opcion) }}</option>
                    </select>

                  </td>
                </tr>

              </tbody>
            </table>
          </div>


          <!-- Card footer -->
          <div class="card-footer py-4">
            <div class="col-md-1">
              <select class="form-control" v-model="limit" @change="cargar">
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
                <option value="999999999">Todos</option>
              </select>
            </div>
            <nav aria-label="...">
              <ul class="pagination justify-content-end mb-0">

                <li v-bind:class="['page-item', { 'disabled': l.url == null }, { 'active': l.active }]"
                  v-for="(l, index) in links" :key="index" style="cursor:pointer;">
                  <a class="page-link" v-if="l.label.includes('Previous')" @click="cargar_url(l.url, null, 'previous')">
                    <i class="fas fa-angle-left"></i>
                  </a>
                  <a class="page-link" v-if="!l.label.includes('Previous') && !l.label.includes('Next')"
                    @click="cargar_url(l.url, l.label)">
                    {{ l.label }}
                  </a>
                  <a class="page-link" v-if="l.label.includes('Next')" @click="cargar_url(l.url, null, 'next')">
                    <i class="fas fa-angle-right"></i>
                  </a>
                </li>

              </ul>
            </nav>

          </div>
        </div>
      </div>
    </div>
    <!-- <pre>columnas: {{columnas}}</pre> -->

    <!-- <pre>String: {{query}}</pre> -->

  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
export default {
  props: ['configuracion', 'cols', 'seleccionable'],
  data: () => ({
    limit: 10,
    spinner: false,
    pagina: 1,
    seleccionados: [],
    //configuracion:{titulo:'Listado'},
    //columnas:[],
    //lista:[],
    //links:[]
  }),
  watch: {
    seleccionable(activo) {
      if (!activo) {
        this.seleccionados = [];
        this.$emit('seleccion-cambio', []);
      }
    },
    lista() {
      // Al cambiar de página/filtro los ids visibles cambian: se limpia la selección
      // para no arrastrar ids que ya no están en pantalla.
      if (this.seleccionados.length) {
        this.seleccionados = [];
        this.$emit('seleccion-cambio', []);
      }
    },
  },
  mounted() {
    /* this.$parent.$on('generar',function(columnas,lista){

      this.columnas = columnas;
      this.lista = lista;
      this.$set(this.columnas , columnas);
    }); */

    this.$parent.$on('spinner', (valor) => {
      //console.log('spinner: '+valor);
      this.spinner = valor;
    });

    this.$parent.$on('cargar', () => {
      let l = localStorage.getItem(this.path);
      if (l) {
        l = JSON.parse(l);
        if (l.pagina) {
          this.pagina = l.pagina;
        }
        if (l.limit) {
          this.limit = l.limit;
        }
        if (l.pagina) {
          this.cargar(true);
        } else {
          this.cargar();

        }
      } else {
        this.cargar();

      }
    });

  },
  methods: {
    buscarConEspera() {
      clearTimeout(this.buscarTimeout);
      this.buscarTimeout = setTimeout(() => {
        this.cargar(false);
      }, 1000);
    },
    async cargar_url(url, pagina = null, tipo = null) {
      if (url) {
        //console.log(url);
        //this.$emit("pagina",url.substr(url.length -1));
        if (pagina != null && tipo == null) {
          this.pagina = pagina
        } else {
          if (tipo == 'next') {
            this.pagina++;
          }

          if (tipo == 'previous') {
            this.pagina--;
          }
        }
        //this.pagina = pagina
        this.cargar(true);
        //this.$emit('cargar_url',url);
        /* await this.axios.get(url,this.cabeceras_json).then((res)=>{
            this.lista = res.data.data.data;
            this.links = res.data.data.links;
            //console.log('listadito',res.data.data.data);
            //$('#empresas').DataTable().draw();
        }).catch(e=>{
            alert(e);
        }) */
      }

    },

    async filtrarOpciones(search, col, index) {
      let append = col.append_parametro != undefined ? col.append_parametro : '';
      await this.axios.get(`${this.api}${col.ruta}?${col.parametro}=${search}${append}&limit=9999999999`, this.cabeceras_json).then((res) => {
        this.columnas[index].opciones = res.data.data.data
        ////console.log('res',res.data.data.data);
      }).catch((e) => {
        //console.log(e);
      });
      ////console.log('search',search)
      ////console.log('col',col)
    },

    async filtrarOpcionesDependiente(search, col, index) {
      //funcion que permite cargar la info de un select con busqueda que depende de otra columna
      let idx = this.columnas.findIndex(c => c.key == col.columna_dependiente);
      let valor = this.columnas[idx].busqueda;
      let string_dependencia = '';
      if (valor != '' && valor != null) {
        string_dependencia = `${col.columna_dependiente}=${valor}&`;
      }
      await this.axios.get(`${this.api}${col.ruta}?${string_dependencia}${col.parametro}=${search}&limit=9999999999`, this.cabeceras_json).then((res) => {
        this.columnas[index].opciones = res.data.data.data
        ////console.log('res',res.data.data.data);
      }).catch((e) => {
        //console.log(e);
      });
      ////console.log('search',search)
      ////console.log('col',col)
    },

    mostrar_boton(item, boton) {
      if (!boton.condicion) return true;
      if (typeof boton.condicion === 'function') return boton.condicion(item);
      return this.devuelve_valor(item, boton.condicion);
    },

    devuelve_valor(item, path, tipo_dato) {
      let keys = path.split('.');
      let valor = item;
      keys.forEach(k => {
        for (var key in valor) {
          if (key == k) {
            valor = valor[key];
          }
        }

      });
      if (tipo_dato == 'datetime') {
        valor = this.$options.filters.fecha_hora(valor);
      }
      if (tipo_dato == 'date') {
        valor = this.$options.filters.fecha(valor);
      }
      return valor;
    },

    cargar(pagina = false) {
      if (pagina == false) {
        this.pagina = 1;
      }
      localStorage.setItem(this.path, JSON.stringify({
        path: this.path,
        pagina: this.pagina,
        limit: this.limit,
        columnas: this.cols.map(c => {
          return {
            key: c.key,
            val: c.busqueda
          }
        })
      }));
      /* console.log({
        path:this.path,
        pagina:this.pagina,
        columnas:this.cols.map(c => {
          return {
            key:c.key,
            val:c.busqueda
          }
        })
      }); */
      this.$emit('cargar', this.query);
    },
    nuevo() {
      this.$emit('nuevo');
    },
    emitir(item, index, boton) {
      this.$emit(`${boton.evento}`, { item, index })
    },

    verificar_condicion(item, path) {
      if (path == undefined) {
        return true
      }

      return item[path];
    },
    limpiar_filtros() {
      this.pagina = 1;
      this.limit = 10;
      this.$emit('refresh');
      //this.cargar(false);
    },
    obtenerColor(clase) {
      if (!clase) return '#333';

      if (clase.includes('primary')) return '#337fd9';
      if (clase.includes('success')) return '#2ecc71';
      if (clase.includes('danger')) return '#e74c3c';
      if (clase.includes('warning')) return '#f39c12';
      if (clase.includes('info')) return '#17a2b8';

      return '#555';
    },
    estaSeleccionado(id) {
      return this.seleccionados.includes(id);
    },
    toggleSeleccion(id) {
      const idx = this.seleccionados.indexOf(id);
      if (idx === -1) {
        this.seleccionados.push(id);
      } else {
        this.seleccionados.splice(idx, 1);
      }
      this.$emit('seleccion-cambio', this.seleccionados);
    },
    toggleSeleccionTodos() {
      if (this.todosSeleccionados) {
        this.seleccionados = [];
      } else {
        this.seleccionados = this.lista.map((item) => item.id);
      }
      this.$emit('seleccion-cambio', this.seleccionados);
    },
    generarPDF() {
      this.$emit('generar_pdf', this.filtros);
    },
    ...mapActions(['inicializar_tabla'])
  },
  components: {
  },
  computed: {
    ...mapState(['api', 'cabeceras_json', 'columnas', 'lista', 'links', 'botones', 'botones_restringidos', 'acciones']),
    todosSeleccionados() {
      return this.lista.length > 0 && this.seleccionados.length === this.lista.length;
    },
    query() {
      let string = '?';
      let and = '';
      let total = this.cols.length - 1;
      this.cols.forEach((c, index) => {
        if (index > 0 && string.length > 0) {
          and = '&';
        } else if (index == total) {
          and = '';
        }
        //console.log(`parametro: ${c.key}, busqueda: ${c.busqueda}`);

        if (c.busqueda !== undefined && c.busqueda !== null && c.busqueda !== '' && c.busqueda.toString().length > 0) {
          if (c.key == 'tipo_empresa') {
            string += `${and}${c.busqueda}=1`;
          } else {
            string += `${and}${c.key}=${c.busqueda}`;
          }
        }
      });
      string += `&limit=${this.limit}&page=${this.pagina}`;
      return string;
    },
    filtros() {
      const filtros = {};

      this.cols.forEach((c) => {
        if (c.busqueda !== undefined && c.busqueda !== null && c.busqueda !== '') {
          filtros[c.key] = c.key === 'tipo_empresa'
            ? `${c.busqueda}=1`
            : c.busqueda;
        }
      });

      return filtros;
    },
    path() {
      return this.$router.currentRoute.path;
    },

    local() {
      return JSON.parse(localStorage.getItem(this.path) || false);
    },
  },
  watch: {
    cols: function (newVal, oldVal) {

    },
  }
}
</script>
<style>
/* .form-control{
    height: calc(1.5em + 1.25rem + 5px);
  } */
.table td {
  padding: 0.5rem;
}

/* .table{
    overflow: auto; height: 100px;
  } */

.table thead tr.cabecera1 {
  position: sticky;
  top: 0;
  z-index: 1;
}

.table thead tr.cabecera2 {
  position: sticky;
  top: 40.6px;
  z-index: 1;
}

.background-red {
  background-color: #E57373;
  color: #fff;
}
</style>
<style scoped>
/* ===== CARD GENERAL ===== */
.card {
  border-radius: 14px;
  border: none;
  box-shadow: 0 8px 24px rgba(13, 31, 69, 0.08);
  overflow: hidden;
}

/* ===== HEADER ===== */
.card-header {
  background: linear-gradient(135deg, #0d1f45, #337fd9);
  color: white;
  border: none;
  padding: 18px 20px;
}

.card-header h3 {
  font-weight: 600;
  font-size: 18px;
  margin: 0;
  color: #fff;
}

/* ===== BOTONES ===== */
.btn {
  border-radius: 8px;
  transition: all 0.2s ease;
}

.btn-primary {
  background: linear-gradient(135deg, #337fd9, #5fa8ff);
  border: none;
}

.btn-primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 10px rgba(51, 127, 217, 0.3);
}

.btn-sm {
  padding: 4px 10px;
  font-size: 12px;
}

/* ===== TABLA ===== */
.table {
  border-collapse: separate;
  border-spacing: 0;
  font-size: 13px;
}

.table thead th {
  font-weight: 600;
  text-transform: uppercase;
  font-size: 11px;
  letter-spacing: 0.5px;
  border: none;
}

/* CABECERA 1 */
.thead-skyblue4 {
  background: #f4f8ff;
  color: #0d1f45;
}

/* CABECERA 2 */
.thead-skyblue3 {
  background: #ffffff;
  border-bottom: 1px solid #e3e8f0;
}

/* FILAS */
.table tbody tr {
  transition: all 0.15s ease;
}

.table tbody tr:hover {
  background-color: #f7fbff;
}

/* CELDAS */
.table td {
  padding: 10px 8px;
  border-top: 1px solid #edf2f7;
  vertical-align: middle;
}

/* ===== INPUTS ===== */
.form-control {
  border-radius: 8px;
  border: 1px solid #dbe3ef;
  font-size: 12px;
  transition: all 0.2s;
}

.form-control:focus {
  border-color: #337fd9;
  box-shadow: 0 0 0 2px rgba(51, 127, 217, 0.15);
}

/* ===== BADGES ===== */
.badge {
  border-radius: 6px;
  padding: 3px 6px;
  font-size: 10px;
}

/* ===== TABLA SCROLL ===== */
.table-responsive {
  height: 600px;
  overflow: auto;
  background: white;
}

/* SOMBRA SCROLL */
.table-responsive::after {
  content: "";
  position: sticky;
  bottom: 0;
  height: 10px;
  display: block;
  background: linear-gradient(to bottom, transparent, rgba(0, 0, 0, 0.05));
}

/* ===== HEADER STICKY ===== */
.table thead tr.cabecera1 {
  position: sticky;
  top: 0;
  z-index: 3;
}

.table thead tr.cabecera2 {
  position: sticky;
  top: 42px;
  z-index: 2;
}

/* ===== PAGINACIÓN ===== */
.pagination .page-item .page-link {
  border-radius: 6px;
  margin: 0 2px;
  border: none;
  color: #337fd9;
}

.pagination .page-item.active .page-link {
  background: #337fd9;
  color: white;
}

.pagination .page-item .page-link:hover {
  background: #e6f0ff;
}

/* ===== SPINNER ===== */
.spinner-3 {
  width: 20px;
  height: 20px;
  border: 3px solid #ffffff80;
  border-top-color: #fff;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  margin-left: auto;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* ===== FILAS DESTACADAS ===== */
.background-red {
  background-color: #ff6b6b;
  color: #fff;
}

.btn-icon {
  background: transparent;
  border: none;
  padding: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-icon i {
  font-size: 16px;
  opacity: 0.85;
}

.btn-icon:hover i {
  transform: scale(1.2);
  opacity: 1;
}

.btn-icon:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(51, 127, 217, 0.4);
  border-radius: 6px;
}

.btn-icon:focus:not(:focus-visible) {
  outline: none;
  box-shadow: none;
}
</style>